var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls132(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 195,
    viewBox: "0 0 32 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9785 28.5938C13.9785 28.5938 15.4365 114.062 16.1033 194.353C16.1033 194.353 17.6058 65.021 18.2281 28.5938H13.9785Z",
    fill: "url(#paint0_linear_710_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1029 31.8763C24.7887 31.8763 31.8299 24.8309 31.8299 16.1401C31.8299 7.44923 24.7887 0.4039 16.1029 0.4039C7.41718 0.4039 0.375977 7.44923 0.375977 16.1401C0.375977 24.8309 7.41718 31.8763 16.1029 31.8763Z",
    fill: "url(#paint1_linear_710_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_710_3",
    x1: 13.9791,
    y1: 111.477,
    x2: 18.2305,
    y2: 111.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_710_3",
    x1: 31.8359,
    y1: 16.1374,
    x2: 0.373132,
    y2: 16.1374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls132);
export default __webpack_public_path__ + "static/media/ils_13_2.4ca2fd2b508fe3d5e0d02f55e710ca3a.svg";
export { ForwardRef as ReactComponent };